import { useHandledDialogFormControls } from '@mews-commander/form';
import { createZodFormResolver } from '@mews/framework';
import { ServicesForm } from '../../../ConfigureProductForm/steps/services/ServicesForm';
import { addProductToServiceSchema } from '../schemas';
import type {
    AddProductToServiceFormProps,
    AddProductToServiceFormContentProps,
    AddProductToServiceFormValues,
} from './types';
import { useAvailableServices, useAddProductToServiceMutation } from './hooks';

const AddProductToServiceFormContent = ({
    basePriceValue,
    serviceKeys,
    servicesList,
}: AddProductToServiceFormContentProps) => {
    return (
        <ServicesForm
            basePriceValue={basePriceValue}
            serviceKeys={serviceKeys}
            servicesList={servicesList}
            enterprises={[]}
        />
    );
};

export const AddProductToServiceForm = ({
    centralProductId,
    enterpriseProductId,
    propertyId,
    serviceIdsInUse,
    basePriceValue,
    ...props
}: AddProductToServiceFormProps) => {
    const { serviceKeys, servicesList, serviceKeyIdPairs } = useAvailableServices({
        propertyId,
        serviceIdsInUse,
    });

    const { handleSubmit } = useAddProductToServiceMutation({
        enterpriseProductId,
        centralProductId,
        propertyId,
        serviceKeyIdPairs,
    });

    const { renderFormContent } = useHandledDialogFormControls<AddProductToServiceFormValues>({
        ...props,
        resolver: createZodFormResolver(addProductToServiceSchema),
        values: {
            serviceProducts: [],
        },
        onSubmit: handleSubmit,
    });

    return renderFormContent(
        <AddProductToServiceFormContent
            basePriceValue={basePriceValue}
            serviceIdsInUse={serviceIdsInUse}
            propertyId={propertyId}
            serviceKeys={serviceKeys}
            servicesList={servicesList}
        />
    );
};
